var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinersclubBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#727273",
    d: "M58,9H6c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V14C63,11.243,60.757,9,58,9z  M40,42H24c-5.523,0-10-4.477-10-10c0-5.523,4.477-10,10-10h16c5.523,0,10,4.477,10,10C50,37.523,45.523,42,40,42z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    fill: "#727273",
    d: "M24,24c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S28.418,24,24,24z M22,36.578 c-1.764-0.772-3-2.529-3-4.578s1.236-3.806,3-4.578V36.578z M26,36.578v-9.156c1.764,0.772,3,2.529,3,4.578S27.764,35.806,26,36.578 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersclubBw);
export default __webpack_public_path__ + "static/media/diners club-bw.5d31d878905f7b2cd9eb29cc9c5669e7.svg";
export { ForwardRef as ReactComponent };